import React from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import {CUSTOM_RENDER_KEYS, LIST_HEADERS} from "./constants";
import DeliveryLogsCard, {RenderStatus} from "./deliveryLogsCard";
import {useDeliveryLogsTableData} from "./useGetTableData";

const DeliveryLogsTable = ({webhookId}) => {
  const {deliveryLogs, paginationConfig, totalCount} =
    useDeliveryLogsTableData(webhookId);

  return (
    <div className="table-container">
      <ListView
        cardContent={DeliveryLogsCard}
        customRenderComponent={RenderStatus}
        customRenderKeys={CUSTOM_RENDER_KEYS}
        listItems={deliveryLogs}
        listHeaders={LIST_HEADERS}
        totalCount={totalCount}
        withPagination={paginationConfig}
      />{" "}
    </div>
  );
};

export default DeliveryLogsTable;
